import { useTranslation } from "react-i18next";

import RetryableErrorState from "~/components/RetryableErrorState";

interface FernieLoadErrorProps {
	onRetry: () => void;
}

const FernieLoadError = ({ onRetry }: FernieLoadErrorProps) => {
	const { t } = useTranslation("common");

	return <RetryableErrorState dense message={t("fernieChat.review.loadError")} onRetry={onRetry} title="" />;
};

export default FernieLoadError;
